import React, { useContext } from 'react';
import PrimaryDesktopActionBar from './PrimaryDesktopActionBar';
import SecondaryDesktopActionBar from './SecondaryDesktopActionBar';
import { ActionBarContext } from '../../ActionBarContext';
export var DesktopActionBar = function (_a) {
    var isOwner = _a.isOwner, deviation = _a.deviation;
    var actionBarType = useContext(ActionBarContext);
    return actionBarType === 'secondary' ? (React.createElement(SecondaryDesktopActionBar, { deviation: deviation, isOwner: isOwner })) : (React.createElement(PrimaryDesktopActionBar, { deviation: deviation, isOwner: isOwner }));
};
DesktopActionBar.displayName = 'DesktopActionBar';
export default DesktopActionBar;
//# sourceMappingURL=DesktopActionBar.js.map